import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bar" }

import { DefineProps } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'QuizHeader',
  props: [
  "questionStatus",
  "barPercentage",
],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", null, [
      _createElementVNode("h4", null, _toDisplayString(__props.questionStatus), 1),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "completion",
          style: _normalizeStyle({ width: __props.barPercentage })
        }, null, 4)
      ])
    ])
  ]))
}
}

})